import { useQuery } from "@tanstack/react-query";
import { privateAxios, publicAxios } from "../axiosInstances";
import { authQueryKeys } from "../query-keys";
import { ResetPasswordEmailSentResponse } from "@ac-expo/api-types";

export const checkIfResetPasswordTokenIsValid = async (token: string) => {
  const { data } = await publicAxios.get<ResetPasswordEmailSentResponse>(
    `/auth/reset-password/${token}`
  );
  return data;
};

export const useCheckIfResetPasswordTokenIsValid = (token?: string) => {
  return useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryKey: authQueryKeys.checkIfResetPasswordTokenIsValid(token!),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => checkIfResetPasswordTokenIsValid(token!),
    enabled: !!token,
  });
};

export const checkIfVerifyEmailTokenIsValid = async (
  token: string,
  email: string
) => {
  const { data } = await publicAxios.post(`/auth/verify-email/${token}`, {
    email,
  });
  return data;
};

export const useCheckIfVerifyEmailTokenIsValid = (
  email = "",
  token?: string
) => {
  return useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryKey: authQueryKeys.checkIfVerifyTokenIsValid(token!, email),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => checkIfVerifyEmailTokenIsValid(token!, email),
    enabled: !!token,
  });
};

/**
 * Fetch a short-lived WebSocket authentication token.
 * This token can be passed as a query parameter when establishing WebSocket connections.
 */
export const fetchWsToken = async (): Promise<{ wsToken: string }> => {
  const { data } = await privateAxios.get<{ wsToken: string }>("/auth/ws-token");
  return data;
};
